import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { IMenu, ISearch } from '../../pages/Dashboard/DashIcons';

const TITLE_BY_PATH = {
  '/dashboard': 'Home',
  '/memories': 'Memories',
  '/usage': 'Usage',
  '/api-key': 'API key',
  '/admin': 'Admin',
  '/privacy': 'Privacy',
  '/terms': 'Terms',
};

// Topbar with a monospace breadcrumb trail and a command-palette-style
// search input. ⌘K focuses the input; pressing Escape blurs it. The
// search field is currently a local filter hint — each page owns its
// own filtering, so we broadcast the query via a custom event the
// pages can optionally subscribe to if they want global search wiring.
const Header = ({ onMenuClick }) => {
  const location = useLocation();
  const inputRef = useRef(null);

  const title = TITLE_BY_PATH[location.pathname] || 'MME';

  useEffect(() => {
    const onKey = (e) => {
      const isMac = typeof navigator !== 'undefined' && /Mac|iP(hone|od|ad)/.test(navigator.platform);
      if ((isMac ? e.metaKey : e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        inputRef.current?.focus();
      } else if (e.key === 'Escape' && document.activeElement === inputRef.current) {
        inputRef.current?.blur();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const handleInput = (e) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('mme:topbar-query', { detail: { value: e.target.value } })
      );
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={onMenuClick}
          aria-label="Open sidebar"
        >
          <IMenu size={18} />
        </button>
        <div className="crumbs">
          <span>railtech</span>
          <span className="sep">/</span>
          <b>MME</b>
          <span className="sep">/</span>
          <b>{title}</b>
        </div>
      </div>
      <div className="search" style={{ width: 320, maxWidth: '40vw' }}>
        <ISearch size={14} />
        <input
          ref={inputRef}
          type="text"
          placeholder="Search memories, tags, packs…"
          onChange={handleInput}
          aria-label="Search"
        />
        <span className="kbd">⌘K</span>
      </div>
    </div>
  );
};

export default Header;
